import { Popconfirm } from 'antd';
import i18next from 'i18next';
import React from 'react';
import { FaLockOpen, FaPencilAlt, FaRegTrashAlt } from 'react-icons/fa';
import Button from '~/components/Button';
import Strong from '~/components/Strong';
import { TableActions } from '~/components/Table';

export const rolesColumns = (handleDelete, handleRole, handlePermissions, isMobile) => {
  if (isMobile) {
    return [
      {
        dataIndex: 'summary',
        key: 'summary',
        render: (_, record) => (
          <div>
            <Strong>{i18next.t('screens:default.name')}:</Strong> {record?.name}
            <br />
            <Strong>{i18next.t('Slug')}:</Strong> {record?.slug}
            {record.id !== 1 && (
              <TableActions align="center" justify="center" isMobile={isMobile}>
                <Button onClick={() => handleRole(record)} title={i18next.t('messages:edit')}>
                  <FaPencilAlt />
                </Button>
                <Popconfirm
                  title={i18next.t('messages:confirmDelete')}
                  okText={i18next.t('messages:delete')}
                  cancelText={i18next.t('messages:no')}
                  onConfirm={() => handleDelete(record.id)}
                >
                  <Button title={i18next.t('messages:edit')}>
                    <FaRegTrashAlt />
                  </Button>
                </Popconfirm>
                <Button onClick={() => handlePermissions(record)}>
                  <FaLockOpen />
                </Button>
              </TableActions>
            )}
          </div>
        ),
      },
    ];
  }

  return [
    {
      title: i18next.t('Nome'),
      key: 'name',
      dataIndex: 'name',
    },
    {
      title: i18next.t('Slug'),
      key: 'slug',
      dataIndex: 'slug',
    },
    {
      title: i18next.t('Ações'),
      key: 'actions',
      width: '140px',
      render: (_, record) => {
        return (
          record.id !== 1 && (
            <TableActions>
              <Button onClick={() => handleRole(record)} title={i18next.t('messages:edit')}>
                <FaPencilAlt />
              </Button>
              <Popconfirm
                title={i18next.t('messages:confirmDelete')}
                okText={i18next.t('messages:delete')}
                cancelText={i18next.t('messages:no')}
                onConfirm={() => handleDelete(record.id)}
              >
                <Button title={i18next.t('messages:edit')}>
                  <FaRegTrashAlt />
                </Button>
              </Popconfirm>
              <Button onClick={() => handlePermissions(record)}>
                <FaLockOpen />
              </Button>
            </TableActions>
          )
        );
      },
    },
  ];
};
